
import { Component, Vue } from "vue-property-decorator";

@Component({
  props: [
    "productId",
    "productName",
    "extras",
    "amount",
    "price",
    "counterItems",
    "status",
    "note",
    "items",
    "showImage",
  ],
  components: {},
})
export default class OrderItemNew extends Vue {
  currentItem: any = null;

  mounted() {
    if (this.$props.items) {
      this.currentItem = this.$props.items.find((item: any) => {
        return item.productId === this.$props.productId;
      });
    }
  }
}
